module.exports = __webpack_public_path__ + "static/media/0027_IMG_LA_CAVE.bb6adafb.png";